import { Box } from '@chakra-ui/react'
import React from 'react'
import OurStoryHeader from './our-story-header'
import OurStoryHeaderFooter from './our-story-header-footer'
import OurStoryBody from './our-story-body'
import useAosAnimation from '@common/hooks/use-aos-animation'

const OurStory = () => {
  useAosAnimation({
    duration: 600,
    once: true
  })

  return (
    <Box>
      <OurStoryHeader />
      <OurStoryBody />
      <OurStoryHeaderFooter />
    </Box>
  )
}

export default OurStory
